export default {
  text: "text",
  number: "number",
  currency: "currency",
  date: "date",
  datetime: "datetime",
  time: "time",
  boolean: "boolean",
  phone: "phone",
  email: "email",
  icon: "icon",
  parrent: "parrent",
  picture: "picture"
};
